import React, { Component } from 'react';
import Sidebar from '../../Common/Sidebar';
import TopNavBar from '../../Common/TopNavBar';
import PageHeader from '../../Common/PageHeader';
import { ProgressBar } from 'primereact/progressbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Footer from '../../Common/Footer';
import CommonValues from '../../Common/Util';
import moment from 'moment';

class EventList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sidebarShow: true,
            loading: false,
            eventList: [],
            searchText: "",
            innerWidth: 1024,

        }
    }
    componentDidMount = () => {
        this.getAllEvents('');
    }
    onKeyClick = (e) => {
        if (e.keyCode == 13) {
            this.onSearchClick();
        }
    }
    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };
    onSearchClick = () => {
        this.getAllEvents(this.state.searchText);
    }
    onRefreshClick = () => {
        this.setState({
            searchText: ''
        })
        this.getAllEvents('');
    }
    actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button p-mr-2 editbtn" onClick={() => this.editEventDetails(rowData.id)} />
                &emsp;
                {/* <Button icon="pi pi-trash" className="p-button p-button-danger editbtn" onClick={() => this.confirmDeleteService(rowData)} /> */}
            </React.Fragment>
        );
    }
    startdateTemplate = (rowData) => {
        return (
            <React.Fragment> 
               <span>{moment(rowData.blogDateTime).format("YYYY-MM-DD")} </span>
            </React.Fragment>
        );
    }
    enddateTemplate = (rowData) => {
        return (
            <React.Fragment>
              
               <span>{moment(rowData.endDate).format("YYYY-MM-DD")} </span>
            </React.Fragment>
        );
    }
    editEventDetails = (eventId) => {
        this.props.history.push(`/event/${eventId}`)

    }
    onNewEventBtnClicked = () => {
        this.props.history.push("/event/0")
    }
    getAllEvents = (searchText) => {
        var axios = require('axios');

        var config = {
            method: 'get',
            url: `${process.env.REACT_APP_Community_Url}/api/events/eventlist?searchText=${searchText}`,
            headers: {}
        };
        this.setState({
            loading: true
        })
        axios(config)
            .then((response) => {
               
                this.setState({
                    eventList: response.data,
                    loading: false
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }
    
    onBarsClick = () => {
        this.setState({
            sidebarShow: !this.state.sidebarShow
        });
    }
    render() {

        const token = CommonValues.GetToken();
        if (token == null) {
            CommonValues.Logout();
        }

        return (
            <div onClick={this.onBodyClick}>
                <div className={this.state.sidebarShow ? "sidebar-mini sidebar-open wrapper" : " wrappersidebar-mini sidebar-closed sidebar-collapse"}>
                    <TopNavBar BarsClick={this.onBarsClick}></TopNavBar>
                    <Sidebar></Sidebar>
                    <div className="content-wrapper">
                        <PageHeader PageTitle="Event Master"></PageHeader>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="row">
                                                    <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12">
                                                        <div
                                                            className="input-group input-group-sm"
                                                        >
                                                            <input
                                                                type="text"
                                                                name="searchText"
                                                                className="form-control float-right"
                                                                placeholder="Search"
                                                                value={this.state.searchText}
                                                                onChange={this.onChange}
                                                                onKeyDown={this.onKeyClick}
                                                            />
                                                            <div className="input-group-append">
                                                                <button type="submit" className="btn btn-default" onClick={this.onSearchClick}>
                                                                    <i className="fas fa-search" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 servicemain">
                                                        <Button label="Refresh" className='p-button-sm' icon="pi pi-sync" onClick={this.onRefreshClick} />
                                                        &nbsp;
                                                        <Button label="New Event" className='p-button-sm' icon="pi pi-plus" onClick={this.onNewEventBtnClicked} />
                                                    </div>

                                                </div>

                                                <div className="card-tools">

                                                </div>
                                            </div>
                                            {
                                                this.state.loading ?
                                                    <>
                                                        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
                                                        <div style={{ height: "600px" }}></div>
                                                    </>

                                                    :
                                                    <div className="card-body table-responsive p-0">
                                                        <div className="d-none d-md-block">
                                                            <DataTable value={this.state.eventList} paginator
                                                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                                                rows={7} responsiveLayout="scroll">

                                                                <Column field="title" header="Name" sortable></Column>
                                                                <Column body={this.startdateTemplate} header="Start" style={{minWidth:"120px"}} field="blogDateTime" sortable ></Column>
                                                                <Column body={this.enddateTemplate} header="End"  style={{minWidth:"120px"}} ></Column>
                                                                <Column field="link" header="Link" ></Column>
                                                                <Column field="location" header="Location" ></Column>
                                                                <Column field="status" header="Status" sortable></Column>
                                                                <Column body={this.actionBodyTemplate} header="Action"></Column>
                                                            </DataTable>
                                                        </div>

                                                        <div className="d-block d-md-none">
                                                            <DataTable value={this.state.eventList} paginator
                                                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                                                rows={7} responsiveLayout="scroll">

                                                                <Column field="title" header="Event Name" sortable></Column>
                                                                <Column body={this.actionBodyTemplate} header="Action"></Column>
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <Footer></Footer>
                </div>
            </div>
        )
            ;
    }
}
export default EventList;
